import { MessageCircle } from "lucide-react";
import { AGENCY, MARQUEE_WORDS } from "@/lib/data";
import { IOSNotification, IOSHighlight } from "@/components/site/iOSKit";

export const Hero = () => {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-screen w-full overflow-hidden flex flex-col justify-end"
        >
            {/* Background video */}
            <div className="absolute inset-0">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster="https://images.pexels.com/photos/8880280/pexels-photo-8880280.jpeg?auto=compress&cs=tinysrgb&w=1920"
                    className="w-full h-full object-cover"
                    data-testid="hero-video"
                >
                    <source
                        src="https://assets.mixkit.co/videos/4005/4005-720.mp4"
                        type="video/mp4"
                    />
                </video>
                <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/60 to-[#0A0A0A]" />
                <div className="grain" />
            </div>

            {/* Floating iOS notification — top right */}
            <div
                className="hidden md:block absolute top-28 right-8 lg:right-16 z-20 animate-fade-up"
                style={{ animationDelay: "0.6s" }}
            >
                <IOSNotification
                    app="IMPACTO VISUAL"
                    title="Trabajemos juntos"
                    message="Asesoría y visita técnica SIN COSTO."
                    time="ahora"
                    icon={MessageCircle}
                    testid="hero-ios-notification"
                />
            </div>

            {/* Hero content */}
            <div className="relative z-10 px-6 md:px-12 lg:px-20 pt-32 flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-8">
                    <span className="w-10 h-px bg-[#FF2A2A]" />
                    <span className="text-[11px] tracking-[0.3em] uppercase text-white/70">
                        Más de 15 años trabajando en la IV Región
                    </span>
                </div>

                <h1
                    data-testid="hero-headline"
                    className="font-display text-[13vw] md:text-[9vw] lg:text-[7.5vw] leading-[0.95] text-balance"
                >
                    <span className="font-serif text-white/90">Hacemos</span>{" "}
                    que
                    <br />
                    tu marca sea
                    <br />
                    <IOSHighlight variant="red">inolvidable.</IOSHighlight>
                </h1>

                <div className="mt-10 max-w-md">
                    <p className="text-white/70 text-base md:text-lg font-light leading-relaxed">
                        Somos una agencia de publicidad y producción creativa
                        360°. Desde publicidad impresa y gran formato hasta el
                        diseño de tu branding y contenido digital de alto
                        impacto.
                    </p>
                </div>
            </div>

            {/* Services strip - static, all visible */}
            <div className="relative z-10 mt-12 border-y border-white/10 bg-black/30 backdrop-blur-sm">
                <div className="flex items-center justify-center flex-wrap gap-x-6 md:gap-x-12 gap-y-2 py-4 px-4">
                    {MARQUEE_WORDS.map((w, i) => (
                        <div
                            key={w}
                            className="flex items-center gap-6 md:gap-12"
                        >
                            <span className="font-display text-xl md:text-3xl lg:text-4xl text-white/80 whitespace-nowrap">
                                {w}
                            </span>
                            {i < MARQUEE_WORDS.length - 1 && (
                                <span className="w-2 h-2 rounded-full bg-[#FF2A2A]" />
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* Bottom sub strip */}
            <div className="relative z-10 px-6 md:px-12 lg:px-20 py-6 flex items-center justify-between text-[11px] tracking-[0.3em] uppercase text-white/50">
                <span data-testid="hero-location">
                    Llegamos a todo el norte de Chile
                </span>
                <a
                    href={AGENCY.whatsappUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-white transition-colors"
                >
                    Scroll ↓
                </a>
            </div>
        </section>
    );
};
